'use client';

import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { useProjectFollowContext } from '@/app/[locale]/(entity)/components/provider/ProjectFollowProvider';
import { Follow } from '@/app/components/Follow/Follow';

export const FollowedUpProjectBanner = ({ inverse = false, bottom = false }: { inverse?: boolean; bottom?: boolean }) => {
  const { isFollowedBtnDisplayed } = useProjectFollowContext();
  const t = useTranslations('PROJECT.FOLLOW');

  return isFollowedBtnDisplayed
    ? (
        <div
          className={classNames({
            'project-banner--separator': inverse,
          })}
        >
          <div
            className={classNames('project-banner', {
              'project-banner--bottom': bottom,
              'project-banner--beardman': inverse,
            })}
          >
            <div
              className={classNames('project-banner__content', {
                'centered-content': !inverse,
                'project-banner__content--beardman': inverse,
              })}
              data-testid="project-banner"
            >
              <span
                className={classNames('project-banner__label', {
                  'project-banner__label--beardman': inverse,
                })}
              >
                {t('STAY_UPDATED')}
              </span>
              <div className="project-banner__button">
                <Follow inverse={inverse} />
              </div>
            </div>
          </div>
        </div>
      )
    : null;
};
